import { render, staticRenderFns } from "./CartaoInformacoesDadosComplementaresDiretorTecnico.vue?vue&type=template&id=5ccccca2&scoped=true"
import script from "./CartaoInformacoesDadosComplementaresDiretorTecnico.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesDadosComplementaresDiretorTecnico.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesDadosComplementaresDiretorTecnico.vue?vue&type=style&index=0&id=5ccccca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccccca2",
  null
  
)

export default component.exports